import { yupResolver } from '@hookform/resolvers/yup';
import { onlyTransferContactValidator } from 'components/OnlyTransferContactModal/validation';
import { FieldValues, FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { Button } from 'styles/Button';
import { Form as StyledForm } from 'styles/Form';
import { InputGroup } from 'styles/InputGroup';
import * as Fields from '../../fields';
import { FormProps } from './types';
import { useOnlyTransferContact } from 'hooks/mutations/useOnlyTransferContact';

const validationSchema = onlyTransferContactValidator();

export function Form({ onRequestClose, contact }: FormProps) {
  const form = useForm<FieldValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      department_id: null,
    },
  });

  const { reset, handleSubmit, formState: { isSubmitting } } = form;

  function handleRequestClose() {
    reset();
    onRequestClose();
  }

  const onlyTransferContactMutation = useOnlyTransferContact();

  async function handleOnlyTransferContact(data: FieldValues) {
    console.log('Errors ', data);
    await onlyTransferContactMutation.mutateAsync({ contactId: contact.id, departmentId: data.department_id });
    handleRequestClose();
  }

  const { errors } = form.formState;
  console.log(errors);

  return (
    <StyledForm onSubmit={handleSubmit(handleOnlyTransferContact as SubmitHandler<FieldValues>)}>
      <FormProvider {...form}>
        <div style={{
          maxHeight: '80vh',
          overflowY: 'auto',
          paddingRight: 10,
          overflow: 'visible'
        }}>
          <Fields.DepartamentId />

          <InputGroup>
            <Button type="submit" fullwidth disabled={isSubmitting}>
              {isSubmitting ? 'Carregando...' : 'Transferir contato'}
            </Button>
          </InputGroup>
        </div>
      </FormProvider>
    </StyledForm>
  );
}
